export default __webpack_public_path__ + "static/media/icon-arrow-down-white.b548ce01.svg";